<template>
  <div class="about" v-html="html">

  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "Supply",
  data() {
    return {
      html: ''
    }
  }, mounted() {
    // 设置语言
    // this.GLOBFUNC.chanLan()
    this.getMessage()
  },
  methods: {
    getMessage() {
      let that = this
      axios.get('/back/supply/supply').then(res => {
        let data = res.data.data[0].message
        that.html = data
      })
    }
  }
}
</script>

<style>
.about {
  transform: translateY(8mm);
}

.c-body > img {
  width: 100%;
  height: 100%;
}

.message_one {
  margin-left: 16.5%;
  margin-right: 16.5%;
  margin-top: 22mm;
}

.message_one > p {
  /*white-space: pre-wrap;*/
  text-align: left;
  line-height: 12mm;
  font-size: 15px;
}

.message_two {
  margin: 0 16.5%;
}

.logos > p:first-of-type {
  margin-top: 11.5mm;
  margin-bottom: 10mm;
  font-size: 15px;
}

.message_two > p:first-of-type {
  /*white-space: pre-wrap;*/
  text-align: left;
  font-weight: bold;
  font-size: 30px;
  margin-top: 22mm;
  margin-bottom: 11.5mm;
  /*background-color: rgb(213,213,213)*/
}

.message_two > p:last-of-type {
  /*border: 1px solid red;*/
  text-align: left;
  /*white-space: pre-wrap;*/
  font-size: 15px;
  line-height: 12mm;
  /*margin-bottom: 35mm;*/
}

.logos > img {
  width: 100%;
  height: auto;
  /*border: 1px solid green;*/
}

.logos > p {
  text-align: left;
}

.message_three {
  margin: 200px auto; /*30mm 16.5% 0 16.5%*/
  line-height: 12mm;
  /*border: 1px solid blue;*/
  max-width: 1052px;
  /*transform: translateY(20mm);*/
}
@media (min-width: 1250px) {
  .message_three {
    margin: 30mm auto !important; /*30mm 16.5% 0 16.5%*/
    line-height: 12mm;
    /*border: 1px solid blue;*/
    max-width: 1052px;
    /*margin-top: 35mm;*/
  }
}

@media (min-width: 1100px) and (max-width: 1249px) {
  .message_three {
    margin: 30mm auto !important; /*30mm 16.5% 0 16.5%*/
    line-height: 12mm;
    /*border: 1px solid blue;*/
    max-width: 954px;
    /*margin-top: 35mm;*/
  }
}

@media (min-width: 510px) and (max-width: 1099px) {
  .message_three {
    margin: 30mm 10% 0 10% !important; /*30mm 16.5% 0 16.5%*/
    line-height: 12mm;
    /*border: 1px solid blue;*/
    max-width: 954px;
    /*margin-top: 35mm;*/
  }
}

.message_three > p {
  text-align: left;
  font-weight: bold;
  font-size: 30px;
  /*background-color: rgb(213,213,213)*/
}

.p_color {
  color: rgb(80, 80, 80);
  text-align: left;
  word-break: break-word;
}

.p_logo {
  color: rgb(16, 16, 16);
}

.log_btn {
  margin-bottom: 140px;
}
</style>



// WEBPACK FOOTER //
// src/views/supply/Supply.vue